module.exports = __webpack_public_path__ + "static/media/helpControl.b4d4b8ab.png";